import { render } from "./Warning.vue?vue&type=template&id=745f7b94"
import script from "./Warning.vue?vue&type=script&lang=ts"
export * from "./Warning.vue?vue&type=script&lang=ts"
script.render = render

export default script